import { Card, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import EmptyActivityComponent from '../../../EmptyComponents/EmptyActivityComponent';
import CardTitle from '../../Shared/CardTitle';
import Title from '../../Shared/Title';
import { recentlyLoggedInCollectionResourceDecoder } from './Decoder';
import RecentlyLoggedInSkeleton from './RecentlyLoggedInSkeleton';
import Row from './Row';

function RecentlyLoggedIn() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'recently-logged-in',
    currentUserStore.links,
    recentlyLoggedInCollectionResourceDecoder,
  );

  if (isLoading) {
    return <RecentlyLoggedInSkeleton />;
  }

  if (error || !data) {
    console.error('Failed to load recently logged in users:', error);
    return emptyFragment();
  }

  return (
    <div className="max-w-[48%] grow sm:max-w-full">
      <CardTitle title="Recently Logged In" />
      <Card className="px-4 py-6" radius="lg">
        <div className="flex justify-between">
          <Title label="Name" />
          <Title label="Last Login" />
        </div>
        <div className="space-y-4">
          {fromArrayMaybe(data.payload)
            .map((resources) => <Row recentlyLoggedInResource={resources} />)
            .getOrElse(() => (
              <EmptyActivityComponent />
            ))}
        </div>
      </Card>
    </div>
  );
}

export default observer(RecentlyLoggedIn);
